import { Box, Text } from '@chakra-ui/react'
import type { InsuranceParamsPropertyDto } from 'BrokerTsLib/src/dtos'
import { formatPersonFullName } from 'BrokerTsLib/src/dtos'
import { Risk, SelectionType } from 'BrokerTsLib/src/enums'

import { useGetRiskVariants, useSelections } from '../../hooks'


export const InsuranceInfoDetailsProperty = (data: InsuranceParamsPropertyDto) => {
  const fullname = formatPersonFullName(data?.policyHolder?.person)
  const address = data?.property.data.address?.fullAddress ?? ''

  const { data: propertyTypesData } = useGetRiskVariants(Risk.PROPERTY_TYPE)
  const { data: realtyTypesData } = useSelections(SelectionType.TypNemovitosti)

  return (
    <>
      <Box sx={{ gridArea: 'details', fontSize: 'sm' }}>
        {fullname.length > 0 && <Text sx={{ fontWeight: 'medium' }}>{fullname}</Text>}


        {address.length > 0 && <Text sx={{ fontWeight: 'medium' }}>{address}</Text>}

        {data.property.type &&
                    <Text sx={{ fontWeight: 'medium' }}>
                      {propertyTypesData?.find(x => x.id == data.property.type)?.name}
                    </Text>}

        {data.property.data.realtyTypeId &&
                    <Text sx={{ fontWeight: 'medium' }}>
                      {realtyTypesData?.find(x => x.id == data.property.data.realtyTypeId)?.description}
                    </Text>}

      </Box>
    </>
  )
}
